import { PageHeader } from "@/components/ui/page-header";

const CarbonReductionPlan = () => {
  return (
    <div>
      <PageHeader
        title="Carbon Reduction Plan"
        description="Our commitment to a sustainable future."
      />
      <div className="container mx-auto px-4 py-16">
        <h2 className="mb-4 text-3xl font-bold">Carbon Reduction Plan</h2>
        <p>Content coming soon...</p>
      </div>
    </div>
  );
};

export default CarbonReductionPlan; 